import { render, staticRenderFns } from "./BatchEditTags.vue?vue&type=template&id=0075ca1c&"
import script from "./BatchEditTags.vue?vue&type=script&lang=js&"
export * from "./BatchEditTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports